import { ApplicationsActions as Actions } from './ApplicationsActions';

export default ({ data, actions, onEdit, ...props }) => {
  const handleEdit = () => onEdit?.(data);

  return <Actions {...props} actions={actions} onEdit={handleEdit} />;
};
